import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { class: "d-flex flex-grow-1 justify-center align-center text-truncate" }
const _hoisted_3 = { style: {"font-size":"3vh"} }

import { computed, onBeforeMount, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertsPanel',
  props: {
    alerts: {}
  },
  setup(__props: any) {

const props = __props;

const alert = ref(0);
const length = computed(() => props.alerts.length);

onBeforeMount(() => {
  const time = 10000;

  setInterval(() => {
    if (length.value > 0) {
      next();
    }
  }, time);
});

function next() {
  alert.value = alert.value + 1 > length.value - 1 ? 0 : alert.value + 1;
}

function prev() {
  alert.value = alert.value - 1 <= 0 ? length.value - 1 : alert.value - 1;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_window, {
      modelValue: alert.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((alert).value = $event)),
      class: "h-100"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
          return (_openBlock(), _createBlock(_component_v_window_item, {
            key: alert,
            class: "h-100 px-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  style: {"font-size":"4vh"}
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-alert")
                  ])),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_3, _toDisplayString(alert), 1)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})